/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface SingleTurnChatGenerationKnowledgeBaseFile
 */
export interface SingleTurnChatGenerationKnowledgeBaseFile {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationKnowledgeBaseFile
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationKnowledgeBaseFile
   */
  knowledgeBase: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatGenerationKnowledgeBaseFile
   */
  file: string;
}

/**
 * Check if a given object implements the SingleTurnChatGenerationKnowledgeBaseFile interface.
 */
export function instanceOfSingleTurnChatGenerationKnowledgeBaseFile(
  value: object,
): value is SingleTurnChatGenerationKnowledgeBaseFile {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('knowledgeBase' in value) || value['knowledgeBase'] === undefined) return false;
  if (!('file' in value) || value['file'] === undefined) return false;
  return true;
}

export function SingleTurnChatGenerationKnowledgeBaseFileFromJSON(
  json: any,
): SingleTurnChatGenerationKnowledgeBaseFile {
  return SingleTurnChatGenerationKnowledgeBaseFileFromJSONTyped(json, false);
}

export function SingleTurnChatGenerationKnowledgeBaseFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatGenerationKnowledgeBaseFile {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    knowledgeBase: json['knowledge_base'],
    file: json['file'],
  };
}

export function SingleTurnChatGenerationKnowledgeBaseFileToJSON(
  value?: Omit<SingleTurnChatGenerationKnowledgeBaseFile, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    knowledge_base: value['knowledgeBase'],
    file: value['file'],
  };
}
